export default "__VITE_ASSET__BBGnpMeM__"